import { LocalizationService } from "src/app/service/localization/localization.service";

export enum TypeCode {
    WINDSPEED, TEMPERATURE, DISTANCE
}

export class TypeCodeName {
    public static getName(number: number, localizationService: LocalizationService) {
        switch (number) {
            case TypeCode.WINDSPEED: 
                return localizationService.translate("weather.windSpeed");
            case TypeCode.TEMPERATURE: 
                return localizationService.translate("weather.temperature");
            case TypeCode.DISTANCE: 
                return localizationService.translate("weather.sight");
        }

        return "Err";
    }
}